import { TypeStorage } from '../../interfaces/TypeStorage/TypeStorage'
import {
  GET_TYPE_STORAGE,
  GET_TYPE_STORAGE_EXITO
} from '../types/typeStorageActionstypes'

export type TypeStorageActions = TypeStorageAction | TypeStorageActionAsync

// Esto va a REDUX
export interface TypeStorageAction {
  type: typeof GET_TYPE_STORAGE_EXITO
  typeStorage: TypeStorage[] | undefined
  error: string | undefined
}

export const getTypeStorageAction = (
  typeStorage?: TypeStorage[],
  error?: string
): TypeStorageActions => {
  return {
    type: GET_TYPE_STORAGE_EXITO,
    typeStorage,
    error
  }
}

// Esto va a SAGA
export interface TypeStorageActionAsync {
  type: typeof GET_TYPE_STORAGE
}

export const getTypeStorageActionAsync = (): TypeStorageActionAsync => {
  return {
    type: GET_TYPE_STORAGE
  }
}
